exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-excel[data-v-2fa7c862]{margin-left:10px;display:inline-block}\n", ""]);

// exports
